/* TDP - sections generiques (cf. tdp-generic.css) : carrousel photos
   (fleches, points). Relance a chaque section rechargee dans l'editeur de
   theme. */
(function () {
  'use strict';
  if (window.tdpGenericLoaded) return;
  window.tdpGenericLoaded = true;

  function initCarousels(root) {
    root.querySelectorAll('[data-tdp-carousel]').forEach(function (car) {
      if (car.dataset.tdpCarouselInit) return;
      car.dataset.tdpCarouselInit = '1';
      var track = car.querySelector('.tdp-carousel__track');
      var slides = car.querySelectorAll('.tdp-carousel__slide');
      var dots = car.querySelectorAll('[data-tdp-carousel-dot]');
      var prev = car.querySelector('[data-tdp-carousel-prev]');
      var next = car.querySelector('[data-tdp-carousel-next]');
      var index = 0;
      function update() {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        if (prev) prev.style.display = index === 0 ? 'none' : '';
        if (next) next.style.display = index === slides.length - 1 ? 'none' : '';
      }
      function go(i) { index = Math.max(0, Math.min(slides.length - 1, i)); update(); }
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initCarousels(document); });
  else initCarousels(document);
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
